import { defineMessages } from 'react-intl';
import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';

const messages = defineMessages({
  portuguese: { id: 'Portuguese', defaultMessage: 'Portuguese' },
  english: { id: 'English', defaultMessage: 'English' },
  label: { id: 'Label', defaultMessage: 'Label' },
  URL: { id: 'URL', defaultMessage: 'URL' },
  URL_Description: {
    id: 'URL_Description',
    defaultMessage:
      'For external links, insert full URL. Eg.: https://www.site.com/path',
  },
  footerLink: { id: 'Footer link', defaultMessage: 'Footer link' },
  links: { id: 'Links', defaultMessage: 'Links' },
  refreshPage: {
    id: 'Refresh the page to see your changes',
    defaultMessage: 'Refresh the page to see your changes',
  },
  leaveEmptyForPortugueseOnly: {
    id: 'Leave empty for Portuguese only',
    defaultMessage: 'Leave empty to display in Portuguese only',
  },
  leaveEmptyForEnglishOnly: {
    id: 'Leave empty for English only',
    defaultMessage: 'Leave empty to display in English only',
  },
});

const footerLinksSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.footerLink),
    properties: {
      'label_pt-br': {
        title: intl.formatMessage(messages.label),
        required: true,
      },
      'url_pt-br': {
        title: intl.formatMessage(messages.URL),
        description: intl.formatMessage(messages.URL_Description),
        required: true,
      },
      label_en: {
        title: intl.formatMessage(messages.label),
        description: intl.formatMessage(messages.leaveEmptyForPortugueseOnly),
        required: true,
      },
      url_en: {
        title: intl.formatMessage(messages.URL),
        description: intl.formatMessage(messages.URL_Description),
        required: true,
      },
    },
    fieldsets: [
      {
        id: 'pt',
        title: intl.formatMessage(messages.portuguese),
        fields: ['label_pt-br', 'url_pt-br'],
      },

      {
        id: 'en',
        title: intl.formatMessage(messages.english),
        fields: ['label_en', 'url_en'],
      },
    ],
    required: [],
  };
};

const FooterLinksWidget = (props) => {
  return (
    <>
      <ObjectListWidget
        schema={footerLinksSchema}
        {...props}
        title={props.intl.formatMessage(messages.links)}
        value={props.value || props.default || []}
        onChange={(id, value) => props.onChange(id, value)}
      />
      <p className="help" style={{ padding: 8, textAlign: 'center' }}>
        {props.intl.formatMessage(messages.refreshPage)}
      </p>
    </>
  );
};

export default FooterLinksWidget;
